export default __webpack_public_path__ + "static/media/ustech.31c64dd2.svg";